import { render } from "./OffcanvasMoveTable.vue?vue&type=template&id=e306803c"
import script from "./OffcanvasMoveTable.vue?vue&type=script&lang=js"
export * from "./OffcanvasMoveTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__